<template>
  <div :class="classObj" class="app-wrapper">
    <AppHeader />
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <div data-simplebar class="main-container">
      <sidebar class="sidebar-container" />
      <div class="main-container-wrap">
        <navbar />
        <app-main />
      </div>
      <div
        v-if="mainContainerLoading"
        class="main-container-mask"
        v-loading="mainContainerLoading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      ></div>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, AppHeader, AppFooter } from "./components";
import { mapGetters } from "vuex";
// import simplebar from 'simplebar';
// import 'simplebar/dist/simplebar.min.css'
// import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: "Layout",
  components: {
    Navbar,
    Sidebar,
    AppMain,
    AppHeader,
    AppFooter,
  },
  // mixins: [ResizeMixin],
  computed: {
    ...mapGetters(["mainContainerLoading"]),
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.hidden {
  overflow: hidden !important;
}
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  min-width: 1893px;
  overflow: auto;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
